/**
 * Step 9 — Project Fields
 *
 * Focuses solely on the Project Fields tab from Project Settings.
 * Content sections visibility and custom field definitions.
 */

import { StepWrapper } from '../StepWrapper';
import SettingsProject from '@/pages/settings-project';

interface StepProps {
  onNext: () => void;
  onBack: () => void;
  onSkip: () => void;
  isLastStep: boolean;
}

export function Step9ProjectFields({ onNext, onBack, onSkip, isLastStep }: StepProps) {
  return (
    <StepWrapper
      barState="default"
      barMessage="Control what information is captured and displayed on every project in your organisation."
      showBack={true}
      showSkip={true}
      nextLabel={isLastStep ? 'Finish Setup →' : 'Next Step →'}
      onNext={onNext}
      onBack={onBack}
      onSkip={onSkip}
    >
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-foreground">Project Fields</h2>
        <p className="text-sm text-muted-foreground mt-0.5">
          Choose which content sections are visible on project overviews and define any custom fields your team needs to track.
        </p>
      </div>
      <div className="rounded-lg border border-border overflow-hidden bg-background shadow-sm">
        <SettingsProject defaultTab="project-fields" />
      </div>
    </StepWrapper>
  );
}
